<template>
	<div class="form-mdfpwd" :id='form.ThisActive.type != "date"?"data":"picker"'>

		<el-form ref="form" :model="form" :rules="rules" label-width="" @submit.native.prevent>
			<div class="pwdhead">
				<!--<span class="pwdtitle">设定</span>-->
				<div class="closediv" @click="close"><span class="close"></span></div>
			</div>
			<el-form-item :title="form.ThisActive.name" :label="showName" prop="ThisActive.value">
				<!--@input="onkeyupFun"-->
				<el-input v-if='form.ThisActive.type != "date"' placeholder="请填写属性值" v-model="form.ThisActive.value" @keyup.enter.native="submitForm('form')" clearable> </el-input>
				<el-date-picker v-if='form.ThisActive.type == "date"' value-format='timestamp' v-model="form.ThisActive.value" type="datetime" placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<button type="button" @click="submitForm('form')" class="ely-button qdButton"><span>确定</span></button>
			<button type="button" @click="close" class="ely-buttonClose"><span>取消</span></button>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'mdfpwd',
		data() {
			var self = this;
			var validatePass = (rule, value, callback) => {
				if(self.form.ThisActive.type == 'date') {
					/*时间类型判断*/
					if(!value) {
						callback(new Error('请选择时间'));
					} else {
						callback();
					}
				} else if(self.form.ThisActive.type == 'text') {
					/*字符串类型判断*/
					if(!value) {
						callback(new Error('请填写属性值'));
					} else {
						callback();
					}
				} else {
					/*除时间与字符串类型的判断*/
					if(!value) {
						callback(new Error('请填写属性值'));
					} else if(!Number(value)) {
						callback(new Error('请填写正确类型'));
					} else if(Number(value) > this.max || Number(value) < this.min) {
						callback(new Error(`输入值超出范围，范围：${this.min}~${this.max}`));
					} else {
						callback();
					}
				}
			};

			return {
				form: {
					id: '',
					value: '',
					valueByIfChange: '', //用于判断是否修改过值
					ThisActive: {},
				},
				rules: {
					ThisActive: {
						value: [{
							type: 'number',
							required: true,
							validator: validatePass,
							trigger: 'change'
						}],
					}
				},
				type: '',
				min: null,
				max: null,
				step: null,
				unit: '',
			}
		},
		computed: {
			showName() {
				if(this.unit == undefined || this.unit == NaN || this.unit == null) {
					return this.form.ThisActive.name
				} else {
					return this.form.ThisActive.name + ' ( ' + this.unit + ' )'
				}
			},
			companyId() {
				return this.$store.state.companyId
			},
		},
		methods: {
			binding(item, type) {
				this.type = type;
				this.form.ThisActive = JSON.parse(JSON.stringify(item));
				let arr = String(this.form.ThisActive.value).split(',')
				let str = '';
				for(let a of arr) {
					str += a
				}
				if(item.type == 'text') {
					this.form.ThisActive.value = str;
				} else if(item.type == 'date') {
					this.form.ThisActive.value = item.date;
				} else {
					this.form.ThisActive.value = Number(str);
				}

				this.valueByIfChange = item.value;
				this.min = Number(this.form.ThisActive.min)
				this.max = Number(this.form.ThisActive.max)
				this.step = Number(this.form.ThisActive.step)
				this.unit = item.unit
				// console.log(this.min,this.max)
				this.$forceUpdate();
			},
			onkeyupFun(value) {
				//this.form.ThisActive.value = value.replace(/^\d+$/,'');
				if(Number(value) > this.max) {
					this.form.ThisActive.value = this.max;
				} else if(Number(value) < this.min) {
					this.form.ThisActive.value = this.min;
				}

			},
			submitForm(formName) {
				if(this.valueByIfChange == this.form.ThisActive.value) {
					//隐藏
					this.$parent.MdfClassify();
					//清楚校验结果
					this.$refs.form.resetFields();
					return;
				} else {
					this.$refs[formName].validate(valid => {
						if(valid) {
							//如果通过验证 to do...
							//console.log(this.form.name)
							//this.common.permission(this);
							var self = this;
							let obj = {
								deviceCode: this.form.ThisActive.DeviceCode,
								property: this.form.ThisActive.id,
								value: this.form.ThisActive.value,
								companyId: this.companyId
							};
							//开启loading
							this.$parent.loadingUpdate(this.form.ThisActive.id);
							//隐藏
							this.$parent.MdfClassify();
							//清楚校验结果
							this.$refs.form.resetFields();
							this.post('/Device/setPropertyValue', obj).then((res) => {
								if(res.success == true) {
									this.$message({
										showClose: true,
										message: '修改属性成功',
										type: 'success'
									});
									//更新看板属性值
									//this.$parent.AttrDataUpdata(this.form.ThisActive.id,this.form.ThisActive.value,this.type);
									//关闭loading
								} else {
									this.$message({
										showClose: true,
										message: `错误码 : ${res.result} ${res.message?res.message:''}`,
										type: 'warning'
									});
								}
								this.$parent.loadingUpdate(this.form.ThisActive.id);
							})
						}
					})
				}

			},
			close() {
				this.$parent.MdfClassify();
			}
		}
	}
</script>

<style scoped>
	#picker >>> .el-input__inner{
	   text-indent: 30px !important;
	}
	.form-mdfpwd >>>.el-date-editor.el-input, .form-mdfpwd >>>.el-date-editor.el-input__inner{
	    width: 100%;
    	float: left;
	}
	.backMessage {
		background-color: #363738 !important;
		border: 0px !important;
	}
	
	.backMessage .el-message__content {
		color: #DADADA !important;
	}
	
	.backMessage .el-message__icon.el-icon-success {
		color: #DADADA !important;
	}
	
	.form-mdfpwd {
		width: 100%;
		height: 100%;
		display: none;
		background: rgba(0, 0, 0, .4);
		position: absolute;
		top: 0;
		bottom: 0;
		left: -1px;
		right: 0;
		z-index: 200;
		margin: auto;
		opacity: 0;
		-webkit-transition: .2s;
		transition: .2s;
	}
	
	.el-form {
		display: block;
		width: 480px;
		height: 265px;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 74px;
		top: -50px;
		transition: .2s;
		background-color: #fff;
		border-radius: 1px;
	}
	
	.pwdhead {
		width: 100%;
		height: 53px;
		/*border-bottom: 1px solid #efefef;*/
	}
	
	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 17px;
		margin-left: 30px;
		margin-top: 14px;
		cursor: context-menu;
	}
	
	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: 25px;
		margin-top: 15px;
		width: 32px;
		height: 27px;
		cursor: pointer;
	}
	
	.pwdhead .close {
		float: right;
		position: relative;
		width: 1px;
		height: 16px;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 5px;
		right: 15px;
	}
	
	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 1px;
		height: 16px;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	
	.el-form-item {
		margin: 0;
		/* padding-left: 13px; */
		/* padding-top: 38px; */
		width: calc(100% - 60px);
		position: absolute !important;
		top: 53px;
		right: 0;
		left: 0;
		/* bottom: 0; */
		margin: auto;
		height: 80px;
		padding: 0 30px;
	}
	
	.el-form-item>>>.el-form-item__label {
		float: left !important;
		width: 100%;
		color: #2c3e50 !important;
		position: relative;
		overflow: hidden;
		height: 40px;
		white-space: nowrap;
		text-overflow: ellipsis;
		user-select: text;
		cursor: text;
		text-align: left;
		padding-right: 0;
	}
	
	.el-form-item>>>.el-form-item__content {
		float: left;
		width: 100%;
	}
	
	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 20px !important;
		/*border: 1px solid rgba(222, 222, 222, 1) !important;*/
		border-radius: 0;
	}
	
	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		border: 1px solid #5087E4;
		width: 90px;
		letter-spacing: 1px;
		font-size: 14px;
		cursor: pointer;
		border-radius: 2px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		left: -140px;
		right: 0;
		margin: auto;
		margin-top: 23px;
		bottom: 40px;
	}
	
	.el-form>>>.qdButton:hover {
		background: #376cc7 !important;
		border-color: #376cc7 !important;
	}
	
	.el-form>>>.ely-buttonClose:hover {
		/*color: #409EFF;*/
		border-color: #C0C4CC;
		/*background-color: #ecf5ff;*/
	}
	
	.el-form>>>.ely-buttonClose {
		background-color: #fff;
		color: #606266;
		border: 1px solid #DCDFE6;
		left: 0;
		right: -140px;
		width: 90px;
		letter-spacing: 1px;
		font-size: 14px;
		cursor: pointer;
		border-radius: 2px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		margin: auto;
		margin-top: 23px;
		bottom: 40px;
	}
	
	.el-form>>>.el-select {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/MapEditor/Preview/preview/MdfClassifyPreview.vue